import styled from 'styled-components';
import { spacing, body2 } from 'ui/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  vertical-align: middle;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
  margin: 0;
`;

export const BodyCheckboxCell = styled(Cell)`
  padding: 0 ${spacing.base} 0 ${spacing.plusQuarter};
`;

export const StyledUL = styled.ul`
  padding-left: 0;
  margin: 0;
`;

export const TableHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
